// Similar to PricingModeEnum provided in types.ts provided by back end; however we need a value to represent the Default case as well on UI

export enum PricingMode {
  ImpliedVolatility = 'ImpliedVolatility', // %
  UnderlyingQuoteCurrency = 'UnderlyingQuoteCurrency', // USD
  BPS = 'BPS', // BPS
  Default = 'Default',
}
